(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3650,3960],{

/***/ 6158:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/**
 * keen-slider 5.4.1
 * The HTML touch slider carousel with the most native feeling you will get.
 * https://keen-slider.io
 * Copyright 2020-2021 Eric Beyer <contact@ericbeyer.de>
 * License: MIT
 * Released on: 2021-05-11
 */

!function(t,e){ true?e(exports,__webpack_require__(2784)):0}(this,(function(t,e){"use strict";function n(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function r(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function i(t){for(var e=1;e<arguments.length;e++){var i=null!=arguments[e]?arguments[e]:{};e%2?r(Object(i),!0).forEach((function(e){n(t,e,i[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(i)):r(Object(i)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(i,e))}))}return t}function o(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var n=[],r=!0,i=!1,o=void 0;try{for(var a,u=t[Symbol.iterator]();!(r=(a=u.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(t){i=!0,o=t}finally{try{r||null==u.return||u.return()}finally{if(i)throw o}}return n}(t,e)||u(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function a(t){return function(t){if(Array.isArray(t))return c(t)}(t)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(t)||u(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function u(t,e){if(t){if("string"==typeof t)return c(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?c(t,e):void 0}}function c(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}function f(t){var e,n,r,o,u,c,f,s,h,v,p,b,m,g,y,w,M,O,j,S,A,x,k,E,P,T,D,C,L,I,X,Y,_,q,z=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},F="data-keen-slider-moves",H="data-keen-slider-v",R=[],V=null,K=!1,W=!1,N=0,U=[];function $(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};t.addEventListener(e,n,r),R.push([t,e,n,r])}function B(t){if(O&&j===Z(t)&&ft()){var n=et(t).x;if(!rt(t)&&E)return J(t);E&&(Kt(),S=n,E=!1),t.cancelable&&t.preventDefault();var r=S-n;P+=Math.abs(r),!T&&P>5&&(T=!0,e.setAttribute(F,!0)),Yt(k(r,Gt)*(lt()?-1:1),t.timeStamp),S=n}}function G(t){O||!ft()||nt(t.target)||(O=!0,E=!0,j=Z(t),T=!1,P=0,rt(t),pt(),M=v,S=et(t).x,Yt(0,t.timeStamp),ut("dragStart"))}function J(t){O&&j===Z(t,!0)&&ft()&&(e.removeAttribute(F),O=!1,gt(),ut("dragEnd"))}function Q(t){return t.changedTouches}function Z(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=e?Q(t):tt(t);return n?n[0]?n[0].identifier:"error":"default"}function tt(t){return t.targetTouches}function et(t){var e=tt(t);return{x:ht()?e?e[0].screenY:t.pageY:e?e[0].screenX:t.pageX,timestamp:t.timeStamp}}function nt(t){return t.hasAttribute(w.preventEvent)}function rt(t){var e=tt(t);if(!e)return!0;var n=e[0],r=ht()?n.clientY:n.clientX,i=ht()?n.clientX:n.clientY,o=void 0!==A&&void 0!==x&&Math.abs(x-i)<=Math.abs(A-r);return A=r,x=i,o}function it(t){ft()&&O&&t.preventDefault()}function ot(){$(window,"orientationchange",Dt),$(window,"resize",(function(){return Tt()})),$(e,"dragstart",(function(t){ft()&&t.preventDefault()})),$(e,"mousedown",G),$(w.cancelOnLeave?e:window,"mousemove",B),w.cancelOnLeave&&$(e,"mouseleave",J),$(window,"mouseup",J),$(e,"touchstart",G,{passive:!0}),$(e,"touchmove",B,{passive:!1}),$(e,"touchend",J,{passive:!0}),$(e,"touchcancel",J,{passive:!0}),$(window,"wheel",it,{passive:!1})}function at(){R.forEach((function(t){t[0].removeEventListener(t[1],t[2],t[3])})),R=[]}function ut(t){w[t]&&w[t](Gt)}function ct(){return w.centered}function ft(){return void 0!==n?n:w.controls}function st(){return w.loop&&r>1}function lt(){return w.rtl}function dt(){return!w.loop&&w.rubberband}function ht(){return!!w.vertical}function vt(){D=window.requestAnimationFrame(bt)}function pt(){D&&(window.cancelAnimationFrame(D),D=null),C=null}function bt(t){C||(C=t);var e=t-C,n=mt(e);if(e>=I)return Yt(L-Y,!1),q?q():void ut("afterChange");var r=_t(n);if(0===r||st()||dt()||_){if(0!==r&&dt()&&!_)return jt();Y+=n,Yt(n,!1),vt()}else Yt(n-r,!1)}function mt(t){return L*X(t/I)-Y}function gt(){switch(ut("beforeChange"),w.mode){case"free":Mt();break;case"free-snap":Ot();break;case"snap":default:yt()}}function yt(){wt((1===f&&0!==p?M:v)+Math.sign(p))}function wt(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:w.duration,r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],i=arguments.length>4&&void 0!==arguments[4]&&arguments[4],o=function(t){return 1+--t*t*t*t*t};St(Ht(t=Ft(t,r,i)),n,o,e)}function Mt(){if(0===m)return!(!_t(0)||st())&&wt(v);var t=w.friction/Math.pow(Math.abs(m),-.5);St(Math.pow(m,2)/t*Math.sign(m),6*Math.abs(m/t),(function(t){return 1-Math.pow(1-t,5)}))}function Ot(){if(0===m)return wt(v);var t=w.friction/Math.pow(Math.abs(m),-.5),e=Math.pow(m,2)/t*Math.sign(m),n=6*Math.abs(m/t),r=(N+e)/(c/f);St((-1===p?Math.floor(r):Math.ceil(r))*(c/f)-N,n,(function(t){return 1-Math.pow(1-t,5)}))}function jt(){if(pt(),0===m)return wt(v,!0);var t=.04/Math.pow(Math.abs(m),-.5),e=Math.pow(m,2)/t*Math.sign(m),n=function(t){return--t*t*t+1},r=m;St(e,3*Math.abs(r/t),n,!0,(function(){St(Ht(Ft(v)),500,n,!0)}))}function St(t,e,n,r,i){pt(),L=t,Y=0,I=e,X=n,_=r,q=i,C=null,vt()}function At(n){var r=l(t);r.length&&(e=r[0],Tt(n),ot(),ut("mounted"))}function xt(){var t,e=z.breakpoints||[];for(var n in e)window.matchMedia(n).matches&&(t=n);if(t===V)return!0;var r=(V=t)?e[V]:z;r.breakpoints&&V&&delete r.breakpoints,w=i(i(i({},Bt),z),r),K=!0,h=null,ut("optionsChanged"),Pt()}function kt(t){return"function"==typeof t?t():d(t,1,Math.max(st()?r-1:r,1))}function Et(){xt(),W=!0,ut("created")}function Pt(t,e){t&&(z=t),e&&(V=null),Ct(),At(e)}function Tt(t){var n=window.innerWidth;if(xt()&&(n!==h||t)){h=n;var i=w.slides;"number"==typeof i?(u=null,r=i):(u=l(i,e),r=u?u.length:0);var a=w.dragSpeed;k="function"==typeof a?a:function(t){return t*a},c=ht()?e.offsetHeight:e.offsetWidth,f=kt(w.slidesPerView),s=d(w.spacing,0,c/(f-1)-1),c+=s,o=ct()?(c/2-c/f/2)/c:0,It();var p=!W||K&&w.resetSlide?w.initial:v;$t(st()?p:qt(p)),ht()&&e.setAttribute(H,!0),K=!1}}function Dt(t){Tt(),setTimeout(Tt,500),setTimeout(Tt,2e3)}function Ct(){at(),Xt(),e&&e.hasAttribute(H)&&e.removeAttribute(H),ut("destroyed")}function Lt(){u&&u.forEach((function(t,e){var n=g[e].distance*c-e*(c/f-s/f-s/f*(f-1)),r=ht()?0:n,i=ht()?n:0,o="translate3d(".concat(r,"px, ").concat(i,"px, 0)");t.style.transform=o,t.style["-webkit-transform"]=o}))}function It(){u&&u.forEach((function(t){var e="calc(".concat(100/f,"% - ").concat(s/f*(f-1),"px)");ht()?(t.style["min-height"]=e,t.style["max-height"]=e):(t.style["min-width"]=e,t.style["max-width"]=e)}))}function Xt(){if(u){var t=["transform","-webkit-transform"];t=[].concat(a(t),ht?["min-height","max-height"]:["min-width","max-width"]),u.forEach((function(e){t.forEach((function(t){e.style.removeProperty(t)}))}))}}function Yt(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:Date.now();Vt(t,n),e&&(t=Nt(t)),N+=t,Wt()}function _t(t){var e=c*(r-1*(ct()?1:f))/f,n=N+t;return n>e?n-e:n<0?n:0}function qt(t){return d(t,0,r-1-(ct()?0:f-1))}function zt(){var t=Math.abs(y),e=N<0?1-t:t;return{direction:p,progressTrack:e,progressSlides:e*r/(r-1),positions:g,position:N,speed:m,relativeSlide:(v%r+r)%r,absoluteSlide:v,size:r,slidesPerView:f,widthOrHeight:c}}function Ft(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return st()?e?Rt(t,n):t:qt(t)}function Ht(t){return-(-c/f*t+N)}function Rt(t,e){var n=(v%r+r)%r,i=n<(t=(t%r+r)%r)?-n-r+t:-(n-t),o=n>t?r-n+t:t-n,a=e?Math.abs(i)<=o?i:o:t<n?i:o;return v+a}function Vt(t,e){clearTimeout(b);var n=Math.sign(t);if(n!==p&&Kt(),p=n,U.push({distance:t,time:e}),b=setTimeout((function(){U=[],m=0}),50),(U=U.slice(-6)).length<=1||0===p)return m=0;var r=U.slice(0,-1).reduce((function(t,e){return t+e.distance}),0),i=U[U.length-1].time,o=U[0].time;m=d(r/(i-o),-10,10)}function Kt(){U=[]}function Wt(){y=st()?N%(c*r/f)/(c*r/f):N/(c*r/f),Ut();for(var t=[],e=0;e<r;e++){var n=(1/r*e-(y<0&&st()?y+1:y))*r/f+o;st()&&(n+=n>(r-1)/f?-r/f:n<-r/f+1?r/f:0);var i=1/f,a=n+i,u=a<i?a/i:a>1?1-(a-1)*f/1:1;t.push({portion:u<0||u>1?0:u,distance:lt()?-1*n+1-i:n})}g=t,Lt(),ut("move")}function Nt(t){if(st())return t;var e=_t(t);if(!dt())return t-e;if(0===e)return t;var n;return t*(n=e/c,(1-Math.abs(n))*(1-Math.abs(n)))}function Ut(){var t=Math.round(N/(c/f));t!==v&&(!st()&&(t<0||t>r-1)||(v=t,ut("slideChanged")))}function $t(t){ut("beforeChange"),Yt(Ht(t),!1),ut("afterChange")}var Bt={centered:!1,breakpoints:null,controls:!0,dragSpeed:1,friction:.0025,loop:!1,initial:0,duration:500,preventEvent:"data-keen-slider-pe",slides:".keen-slider__slide",vertical:!1,resetSlide:!1,slidesPerView:1,spacing:0,mode:"snap",rtl:!1,rubberband:!0,cancelOnLeave:!0},Gt={controls:function(t){n=t},destroy:Ct,refresh:function(t){Pt(t,!0)},next:function(){wt(v+1,!0)},prev:function(){wt(v-1,!0)},moveToSlide:function(t,e){wt(t,!0,e)},moveToSlideRelative:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2?arguments[2]:void 0;wt(t,!0,n,!0,e)},resize:function(){Tt(!0)},details:function(){return zt()},options:function(){var t=i({},w);return delete t.breakpoints,t}};return Et(),Gt}function s(t){return Array.prototype.slice.call(t)}function l(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:document;return"function"==typeof t?s(t()):"string"==typeof t?s(e.querySelectorAll(t)):t instanceof HTMLElement!=!1?[t]:t instanceof NodeList!=!1?t:[]}function d(t,e,n){return Math.min(Math.max(t,e),n)}Math.sign||(Math.sign=function(t){return(t>0)-(t<0)||+t});var h=function t(e,n){var r=Object.prototype.toString.call(e);if(r!==Object.prototype.toString.call(n))return!1;if(["[object Array]","[object Object]"].indexOf(r)<0)return!1;var i="[object Array]"===r?e.length:Object.keys(e).length;if(i!==("[object Array]"===r?n.length:Object.keys(n).length))return!1;var o=function(e,n){var r=Object.prototype.toString.call(e);if(["[object Array]","[object Object]"].indexOf(r)>=0){if(!t(e,n))return!1}else{if(r!==Object.prototype.toString.call(n))return!1;if("[object Function]"===r){if(e.toString()!==n.toString())return!1}else if(e!==n)return!1}};if("[object Array]"===r){for(var a=0;a<i;a++)if(!1===o(e[a],n[a]))return!1}else for(var u in e)if(e.hasOwnProperty(u)&&!1===o(e[u],n[u]))return!1;return!0};t.default=f,t.useKeenSlider=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.useRef(),r=e.useRef();function i(t){return h(r.current,t)||(r.current=t),r.current}var a=e.useState(null),u=o(a,2),c=u[0],s=u[1];return e.useEffect((function(){var t=new f(n.current,r.current);return s(t),function(){t.destroy()}}),[i(t)]),[n,c]},Object.defineProperty(t,"__esModule",{value:!0})}));
//# sourceMappingURL=react.js.map


/***/ }),

/***/ 43650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CMS_BannerSlider; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/use-media/lib/index.js
var lib = __webpack_require__(81145);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/Slider/index.js + 7 modules
var Slider = __webpack_require__(12109);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/index.js + 1 modules
var Badge = __webpack_require__(68113);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Button/index.js + 1 modules
var Button = __webpack_require__(62772);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/BannerSliderItemCard/BannerSliderItemCard.jsx





var Title = function(param) {
    var children = param.children, isH1 = param.isH1, className = param.className;
    return isH1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: className,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: className,
        children: children
    });
};
var BannerSliderItemCard = function(param) {
    var info = param.info, isMobile = param.isMobile, className = param.className, handleBtnClick = param.handleBtnClick;
    var button = info.button, text_color = info.text_color, title = info.title, is_h1 = info.is_h1, content = info.content, background_color = info.background_color, alignment = info.alignment;
    var withButton = Boolean(button.link && button.text);
    var noBackground = background_color === "no";
    var contentMarkup = {
        __html: content
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(className, "sm:min-h-0", {
            "min-h-48": !isMobile && alignment === "center",
            "bg-ui-white": background_color === "yes",
            "bg-transparent": background_color === "no"
        }),
        style: background_color !== "yes" && background_color !== "no" ? {
            backgroundColor: background_color
        } : {},
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                className: "mb-4 font-heading text-h2 font-body-normal sm:mb-6 sm:text-sliderH1",
                style: {
                    color: text_color ? text_color : "#000000"
                },
                isH1: is_h1,
                children: title
            }),
            content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    color: text_color || "#000000"
                },
                className: "font-body font-body-regular",
                dangerouslySetInnerHTML: contentMarkup
            }),
            withButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                size: "md",
                className: classnames_default()({
                    "mt-2": title || content,
                    "bg-opacity-90 sm:bg-opacity-100": !noBackground
                }),
                onClick: handleBtnClick(button.link),
                children: button.text
            })
        ]
    });
};
BannerSliderItemCard.defaultProps = {};
BannerSliderItemCard.propTypes = {
    info: prop_types.object,
    className: prop_types.string,
    handleBtnClick: prop_types.func.isRequired
};
/* harmony default export */ var BannerSliderItemCard_BannerSliderItemCard = (BannerSliderItemCard);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/BannerSliderItemCard/index.js


// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/BannerSliderItem/BannerSliderItem.module.scss
var BannerSliderItem_module = __webpack_require__(99423);
var BannerSliderItem_module_default = /*#__PURE__*/__webpack_require__.n(BannerSliderItem_module);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/BannerSliderItem/BannerSliderItem.jsx









var BackgroundImage = function(param) {
    var title = param.title, image = param.image, index = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute inset-0 h-full w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative h-full min-h-full w-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                alt: title,
                src: image,
                layout: "fill",
                objectFit: "cover",
                objectPosition: "center",
                quality: 70,
                priority: index === 0
            })
        })
    });
};
var SlideWrapper = function(param) {
    var children = param.children, href = param.href;
    if (!href) return children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
        className: "block",
        underline: false,
        href: href,
        children: children
    });
};
var BannerSliderItem = function(param) {
    var index = param.index, item = param.item, isMobile = param.isMobile, handleBtnClick = param.handleBtnClick;
    var title = item.title, alignment = item.alignment, image = item.image, button = item.button, link = item.link, background_color = item.background_color;
    var buttonLink = button.link;
    var noBackground = background_color === "no";
    var center = alignment === "center";
    var left = alignment === "left";
    var right = alignment === "right";
    var sliderItemWrapperClassName = classnames_default()("w-full flex relative mx-auto", {
        "xxs:items-end": !center && noBackground,
        "xxs:items-center": center && noBackground,
        "sm:justify-center sm:items-center": center,
        "sm:justify-start sm:items-end": left && !noBackground,
        "sm:justify-start sm:items-center": left && noBackground,
        "sm:justify-end sm:items-end": right,
        "sm:justify-end sm:items-center": right && noBackground,
        "px-3 justify-center items-end": !noBackground
    });
    var sliderItemCardWrapperClassName = "w-full sm:w-3/4 lg:w-1/2";
    var sliderItemCardClassName = classnames_default()({
        "sm:p-12 sm:rounded-xl sm:text-center": center,
        "sm:p-12 sm:rounded-tl-xl sm:rounded-tr-xl sm:rounded-b-none sm:text-left": left,
        "sm:p-12 sm:rounded-tl-xl sm:rounded-tr-xl sm:text-right": right,
        "px-4 pb-6": noBackground,
        "px-6 pt-8 pb-8 w-full rounded-tl-xl rounded-tr-xl rounded-b-none bg-opacity-90 text-center mx-auto": !noBackground,
        "text-center": center && noBackground,
        "text-left": left && noBackground,
        "text-right": right && noBackground
    });
    var badgeClassName = classnames_default()("absolute right-0", {
        "top-0 text-caption": isMobile,
        "bottom-0": !isMobile
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper, {
        href: buttonLink !== "" && button.text === "" ? buttonLink : null,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("relative w-full px-4 pt-5 md:px-8", (BannerSliderItem_module_default()).SlideWrapper),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage, {
                    title: title,
                    image: image,
                    index: index
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: sliderItemWrapperClassName,
                    style: {
                        maxWidth: "1052px",
                        height: !isMobile ? "500px" : "350px"
                    },
                    children: buttonLink !== "" && button.text !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                        href: buttonLink,
                        underline: false,
                        className: sliderItemCardWrapperClassName,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSliderItemCard_BannerSliderItemCard, {
                            info: item,
                            className: sliderItemCardClassName,
                            handleBtnClick: handleBtnClick,
                            isMobile: isMobile
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: sliderItemCardWrapperClassName,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSliderItemCard_BannerSliderItemCard, {
                            info: item,
                            className: sliderItemCardClassName,
                            handleBtnClick: handleBtnClick,
                            isMobile: isMobile
                        })
                    })
                }),
                link.text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    className: badgeClassName,
                    href: link.link,
                    type: isMobile ? "linkTop" : "linkBottom",
                    children: link.text
                })
            ]
        })
    });
};
BannerSliderItem.defaultProps = {};
BannerSliderItem.propTypes = {
    index: prop_types.number,
    item: prop_types.object,
    isMobile: prop_types.bool,
    handleBtnClick: prop_types.func.isRequired
};
/* harmony default export */ var BannerSliderItem_BannerSliderItem = (BannerSliderItem);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/BannerSliderItem/index.js


;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/BannerSlider/BannerSlider.jsx







var BannerSlider = /*#__PURE__*/ react.memo(function(param) {
    var slides = param.slides, handleBtnClick = param.handleBtnClick;
    var isMobile = (0,lib/* default */.ZP)({
        maxWidth: 640
    });
    var ref = (0,react.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    if (!slides || !slides.length) return "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
            id: "bannerSlider",
            arrows: !isMobile && isLoaded,
            autoplay: true,
            options: {
                created: function() {
                    setIsLoaded(true);
                },
                mounted: function() {
                    setIsLoaded(false);
                },
                destroyed: function() {
                    setIsLoaded(false);
                }
            },
            slideClassName: classnames_default()({
                "border-0 opacity-1": isLoaded,
                "border opacity-0": !isLoaded
            }),
            arrowsWrapperClassName: classnames_default()({
                "opacity-0 hidden": !isLoaded,
                "opacity-1 block": isLoaded
            }),
            children: slides.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSliderItem_BannerSliderItem, {
                    index: index,
                    item: item,
                    isMobile: isMobile,
                    handleBtnClick: handleBtnClick
                }, "".concat(item.image, "+").concat(index));
            })
        })
    });
});
BannerSlider.defaultProps = {};
BannerSlider.propTypes = {
    slides: prop_types.array.isRequired,
    handleBtnClick: prop_types.func.isRequired
};
/* harmony default export */ var BannerSlider_BannerSlider = (BannerSlider);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/BannerSlider/index.js


;// CONCATENATED MODULE: ./components/cms/CMS_BannerSlider.js






var CMS_Slider_Comp = function(param) {
    var content = param.content;
    var router = (0,next_router.useRouter)();
    var handleBtnClickhandleBtnClick = function(e) {
        return src/* links.handleRedirect */.Ok.handleRedirect(e, router);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSlider_BannerSlider, {
        slides: (0,src/* get_ */.jR)(content, [
            "items"
        ], []),
        handleBtnClick: handleBtnClickhandleBtnClick
    });
};
CMS_Slider_Comp.defaultProps = {};
CMS_Slider_Comp.propTypes = {
    content: prop_types.object.isRequired
};
var CMS_Slider = /*#__PURE__*/ react.memo(CMS_Slider_Comp);
/* harmony default export */ var CMS_BannerSlider = (CMS_Slider);


/***/ }),

/***/ 68113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Badge_Badge; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/Badge.jsx








var Badge = function(param) {
    var className = param.className, bgColor = param.bgColor, textColor = param.textColor, type = param.type, children = param.children, href = param.href, style = param.style;
    var _obj;
    var rootClass = classnames_default()(className, "inline-block font-body", (_obj = {
        "shadow-down text-small rounded-l-none rounded-r-sm px-2 py-1": type === "generic" || type === "initial" || type === "stockout",
        "text-small rounded-xxl px-2 py-1": type === "round",
        "shadow-down text-caption leading-tight border-solid border border-brand-primary-700 rounded-sm px-1 py-0": type === "discount",
        "shadow-down font-body font-body-normal text-small underline rounded-bl-md px-2 py-1 cursor-pointer": type === "linkTop",
        "shadow-down font-body font-body-normal text-small underline rounded-tl-md px-2 py-1 cursor-pointer": type === "linkBottom",
        "bg-brand-secondary-700": !bgColor && type === "generic",
        "bg-ui-success": !bgColor && type === "round",
        "bg-brand-tertiary-500": !bgColor && type === "initial",
        "bg-ui-gray-300": !bgColor && type === "stockout",
        "bg-ui-white": !bgColor && type === "discount"
    }, (0,_define_property/* default */.Z)(_obj, bgColor, bgColor), (0,_define_property/* default */.Z)(_obj, "text-ui-white", !textColor && (type === "generic" || type === "initial" || type === "round")), (0,_define_property/* default */.Z)(_obj, "text-ui-gray-900", !textColor && type === "stockout"), (0,_define_property/* default */.Z)(_obj, "text-brand-primary-700", !textColor && type === "discount"), (0,_define_property/* default */.Z)(_obj, "text-ui-black", !textColor && (type === "linkTop" || type === "linkBottom")), (0,_define_property/* default */.Z)(_obj, "font-body-normal ".concat(textColor), textColor), _obj));
    var colorRGB = "#FDF2F1";
    var colorRGBA = colorRGB + "80";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: rootClass,
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            backgroundColor: type === "linkBottom" || type === "linkTop" ? colorRGBA : ""
        }),
        children: type === "linkBottom" || type === "linkTop" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
            href: href,
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    });
};
Badge.defaultProps = {
    type: "generic"
};
Badge.propTypes = {
    className: prop_types.string,
    textColor: prop_types.string,
    bgColor: prop_types.string,
    /** Badge variants: intial, stock-out, generic, discount, etc. */ type: prop_types.oneOf([
        "generic",
        "round",
        "initial",
        "stockout",
        "discount",
        "linkTop",
        "linkBottom", 
    ]),
    children: prop_types.string.isRequired,
    href: prop_types.string
};
/* harmony default export */ var Badge_Badge = (Badge);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/index.js



/***/ }),

/***/ 75017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BulletIndicator_BulletIndicator; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/BulletIndicator/BulletIndicator.jsx





var BulletIndicator = function(param) {
    var className = param.className, bulletSize = param.bulletSize, type = param.type, onClick = param.onClick;
    var _obj;
    var bulletClassName = classnames_default()(className, "transition duration-300 ease-out", (_obj = {
        "rounded-full mx-1": type === "dot",
        "w-3 h-3": type === "dot" && !bulletSize
    }, (0,_define_property/* default */.Z)(_obj, bulletSize, bulletSize), (0,_define_property/* default */.Z)(_obj, "w-full h-[5px]", type === "rect"), _obj));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: bulletClassName,
        onClick: onClick
    });
};
BulletIndicator.defaultProps = {
    type: "dot"
};
BulletIndicator.propTypes = {
    className: prop_types.string,
    bulletSize: prop_types.string,
    type: prop_types.oneOf([
        "dot",
        "rect"
    ]),
    onClick: prop_types.func
};
/* harmony default export */ var BulletIndicator_BulletIndicator = (BulletIndicator);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/BulletIndicator/index.js



/***/ }),

/***/ 12109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Slider_Slider; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/keen-slider/react.js
var keen_slider_react = __webpack_require__(6158);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(12073);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/ChevronLeftIcon.js
var ChevronLeftIcon = __webpack_require__(16244);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/CircleIcon/CircleIcon.jsx





var CircleIcon = function(param) {
    var right = param.right, className = param.className, iconSize = param.iconSize, circleSize = param.circleSize, circleBg = param.circleBg, isDisabled = param.isDisabled, onClick = param.onClick;
    var Icon = right ? ChevronRightIcon/* default */.Z : ChevronLeftIcon/* default */.Z;
    var buttonClassName = classnames_default()(className, circleBg, "".concat(circleSize ? circleSize : "w-12 h-12"), "rounded-full z-75", "transition transform duration-300 ease-out", {
        "bg-brand-primary-100 shadow-down hover:bg-brand-primary-300 hover:shadow-heavy": !isDisabled && !circleBg,
        "bg-ui-gray-300 cursor-default": isDisabled
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: buttonClassName,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
            className: classnames_default()("block", iconSize ? iconSize : "mx-auto h-6 lg:h-8", {
                "text-ui-gray-500": isDisabled
            })
        })
    });
};
CircleIcon.defaultProps = {
    right: false,
    isDisabled: false
};
CircleIcon.propTypes = {
    right: prop_types.bool,
    isDisabled: prop_types.bool,
    iconSize: prop_types.string,
    circleSize: prop_types.string
};
/* harmony default export */ var CircleIcon_CircleIcon = (CircleIcon);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/CircleIcon/index.js


;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/SliderControlArrows/SliderControlArrows.jsx





var SliderControlArrows = function(param) {
    var arrowsWrapperClassName = param.arrowsWrapperClassName, arrowsClassName = param.arrowsClassName, arrowCircleSize = param.arrowCircleSize, arrowCircleBg = param.arrowCircleBg, arrowIconSize = param.arrowIconSize, leftArrowPosition = param.leftArrowPosition, rightArrowPosition = param.rightArrowPosition, slider = param.slider, currentSlide = param.currentSlide;
    var circleIconClassName = classnames_default()("arrow", arrowsClassName);
    var isLoop = slider.options().loop;
    var disabledRight = currentSlide === slider.details().size - slider.details().slidesPerView;
    var disabledLeft = currentSlide === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: arrowsWrapperClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleIcon_CircleIcon, {
                className: classnames_default()(circleIconClassName, "arrow--left", "".concat(leftArrowPosition ? leftArrowPosition : "left-4"), {
                    "hover:-translate-x-1": !disabledLeft
                }),
                circleSize: arrowCircleSize ? arrowCircleSize : "w-10 h-10 lg:w-12 lg:h-12",
                iconSize: arrowIconSize,
                onClick: function(e) {
                    return e.stopPropagation() || slider.prev();
                },
                isDisabled: !isLoop && disabledLeft,
                circleBg: arrowCircleBg
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleIcon_CircleIcon, {
                right: true,
                className: classnames_default()(circleIconClassName, "arrow--right", "".concat(rightArrowPosition ? rightArrowPosition : "right-4"), {
                    "hover:translate-x-1": !disabledRight
                }),
                circleSize: arrowCircleSize ? arrowCircleSize : "w-10 h-10 lg:w-12 lg:h-12",
                iconSize: arrowIconSize,
                onClick: function(e) {
                    return e.stopPropagation() || slider.next();
                },
                isDisabled: !isLoop && disabledRight,
                circleBg: arrowCircleBg
            })
        ]
    });
};
SliderControlArrows.defaultProps = {};
SliderControlArrows.propTypes = {
    arrowsWrapperClassName: prop_types.string,
    arrowsClassName: prop_types.string,
    arrowCircleSize: prop_types.string,
    arrowCircleBg: prop_types.string,
    arrowIconSize: prop_types.string,
    leftArrowPosition: prop_types.string,
    rightArrowPosition: prop_types.string,
    slider: prop_types.object,
    currentSlide: prop_types.number
};
/* harmony default export */ var SliderControlArrows_SliderControlArrows = (SliderControlArrows);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/SliderControlArrows/index.js


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/BulletIndicator/index.js + 1 modules
var BulletIndicator = __webpack_require__(75017);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/SliderControlBullets/SliderControlBullets.jsx






var SliderControlBullets = function(param) {
    var bulletsWrapperClassName = param.bulletsWrapperClassName, bulletType = param.bulletType, bulletsClassName = param.bulletsClassName, bulletSize = param.bulletSize, currentSlide = param.currentSlide, slider = param.slider;
    var wrapperClasName = classnames_default()(bulletsWrapperClassName, "dots inline-flex");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: wrapperClasName,
        children: (0,_to_consumable_array/* default */.Z)(Array(slider.details().size).keys()).map(function(idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletIndicator/* default */.Z, {
                type: bulletType,
                onClick: function() {
                    slider.moveToSlideRelative(idx);
                },
                className: classnames_default()(bulletsClassName, "cursor-pointer bg-ui-gray-300 hover:opacity-50", {
                    "!bg-ui-gray-900": currentSlide === idx
                }),
                bulletSize: bulletSize ? bulletSize : "w-2.5 h-2.5 lg:w-3 lg:h-3"
            }, idx);
        })
    });
};
SliderControlBullets.defaultProps = {
    bulletType: "dot"
};
SliderControlBullets.propTypes = {
    bulletsWrapperClassName: prop_types.string,
    bulletType: prop_types.string,
    bulletsClassName: prop_types.string,
    bulletSize: prop_types.string,
    currentSlide: prop_types.number,
    slider: prop_types.object
};
/* harmony default export */ var SliderControlBullets_SliderControlBullets = (SliderControlBullets);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/SliderControlBullets/index.js


// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/Slider/Slider.module.scss
var Slider_module = __webpack_require__(43090);
var Slider_module_default = /*#__PURE__*/__webpack_require__.n(Slider_module);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/Slider/Slider.jsx










var SliderItemWrapper = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: react.Children.map(children, function(child) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(className, "keen-slider__slide"),
                children: child
            });
        })
    });
};
var Slider = function(param) {
    var children = param.children, sliderWrapperClassName = param.sliderWrapperClassName, slideClassName = param.slideClassName, arrows = param.arrows, arrowsWrapperClassName = param.arrowsWrapperClassName, arrowsClassName = param.arrowsClassName, arrowCircleSize = param.arrowCircleSize, arrowCircleBg = param.arrowCircleBg, arrowIconSize = param.arrowIconSize, leftArrowPosition = param.leftArrowPosition, rightArrowPosition = param.rightArrowPosition, bullets = param.bullets, bulletsWrapperClassName = param.bulletsWrapperClassName, bulletType = param.bulletType, bulletsClassName = param.bulletsClassName, bulletSize = param.bulletSize, id = param.id, options = param.options, autoplay = param.autoplay, autoplaySpeed = param.autoplaySpeed, refresh = param.refresh;
    var ref = (0,react.useState)(0), currentSlide = ref[0], setCurrentSlide = ref[1];
    var ref1 = (0,react.useState)(false), pause = ref1[0], setPause = ref1[1];
    var containerRef = (0,react.useRef)(null);
    var timer = (0,react.useRef)(null);
    var initialOptions = {
        initial: 0,
        loop: true,
        duration: 1000,
        dragStart: function() {
            setPause(true);
        },
        dragEnd: function() {
            setPause(false);
        },
        slideChanged: function slideChanged(s) {
            setCurrentSlide(s.details().relativeSlide);
        },
        controls: true,
        spacing: 0,
        breakpoints: {
            "(min-width: 640px)": {
                controls: false,
                slidesPerView: 1
            }
        },
        resetSlide: true
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,keen_slider_react.useKeenSlider)((0,_object_spread/* default */.Z)({}, initialOptions, options)), 2), sliderRef = ref2[0], slider = ref2[1];
    (0,react.useEffect)(function() {
        if (slider && refresh) {
            slider.refresh((0,_object_spread/* default */.Z)({}, initialOptions, options));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        refresh
    ]);
    (0,react.useEffect)(function() {
        if (autoplay) {
            containerRef.current.addEventListener("mouseover", function() {
                setPause(true);
            });
            containerRef.current.addEventListener("mouseout", function() {
                setPause(false);
            });
        }
    }, [
        containerRef,
        autoplay
    ]);
    (0,react.useEffect)(function() {
        if (autoplay) {
            timer.current = setInterval(function() {
                if (!pause && slider) {
                    slider.next();
                }
            }, autoplaySpeed ? autoplaySpeed : 6000);
        }
        return function() {
            clearInterval(timer.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pause,
        slider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: classnames_default()((Slider_module_default()).KeenSliderWrapper, sliderWrapperClassName, "relative"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: sliderRef,
                id: id,
                className: "keen-slider",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderItemWrapper, {
                    children: children,
                    className: classnames_default()(slideClassName)
                })
            }),
            arrows && slider && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderControlArrows_SliderControlArrows, {
                slider: slider,
                currentSlide: currentSlide,
                arrowsWrapperClassName: arrowsWrapperClassName,
                arrowsClassName: classnames_default()(arrowsClassName, "absolute -mt-6 top-1/2"),
                arrowCircleSize: arrowCircleSize,
                arrowCircleBg: arrowCircleBg,
                arrowIconSize: arrowIconSize,
                leftArrowPosition: leftArrowPosition,
                rightArrowPosition: rightArrowPosition
            }),
            bullets && slider && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderControlBullets_SliderControlBullets, {
                slider: slider,
                currentSlide: currentSlide,
                bulletsWrapperClassName: classnames_default()(bulletsWrapperClassName, "absolute transform -translate-x-1/2 left-1/2"),
                bulletType: bulletType,
                bulletsClassName: bulletsClassName,
                bulletSize: bulletSize
            })
        ]
    });
};
Slider.defaultProps = {
    arrows: true,
    bullets: true,
    autoplay: false,
    bulletsWrapperClassName: "bottom-2 md:bottom-6"
};
Slider.propTypes = {
    children: prop_types.oneOfType([
        prop_types.object,
        prop_types.array,
        prop_types.node
    ]),
    sliderWrapperClassName: prop_types.string,
    arrows: prop_types.bool,
    arrowsWrapperClassName: prop_types.string,
    arrowsClassName: prop_types.string,
    arrowCircleSize: prop_types.string,
    arrowCircleBg: prop_types.string,
    arrowIconSize: prop_types.string,
    bullets: prop_types.bool,
    bulletsWrapperClassName: prop_types.string,
    bulletType: prop_types.string,
    bulletsClassName: prop_types.string,
    bulletSize: prop_types.string,
    id: prop_types.string,
    options: prop_types.object,
    autoplay: prop_types.bool,
    autoplaySpeed: prop_types.number,
    refresh: prop_types.any
};
/* harmony default export */ var Slider_Slider = (Slider);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/Slider/index.js



/***/ }),

/***/ 99423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SlideWrapper":"BannerSliderItem_SlideWrapper__HxIPK"};

/***/ }),

/***/ 43090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"KeenSliderWrapper":"Slider_KeenSliderWrapper__PbLhc"};

/***/ }),

/***/ 16244:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function ChevronLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.636 22a.337.337 0 01-.24-.104l-9.152-9.273a.868.868 0 01-.06-.07c-.267-.344-.24-.872.06-1.176l9.15-9.273A.34.34 0 0116.637 2c.104 0 .204.052.273.14a.46.46 0 01-.031.588L7.726 12l9.151 9.27c.15.153.165.418.031.59a.344.344 0 01-.272.14z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronLeftIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 12073:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.364 22a.345.345 0 01-.272-.14.46.46 0 01.03-.588L16.274 12l-9.15-9.27a.461.461 0 01-.032-.59c.07-.088.169-.14.273-.14a.34.34 0 01.24.104l9.152 9.272c.021.022.04.043.059.067.268.346.241.875-.058 1.18l-9.152 9.273a.338.338 0 01-.241.104z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronRightIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);